module.exports = __webpack_public_path__ + "img/PillPARA.1ad32da8.svg";